// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { Action } from "redux"
import { catchError, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/additionalUi"
import { WARN_MULTIPLE_TAGS } from "./index"
import { ofType } from "redux-observable"

export type StorageReader = () => Observable<boolean>

export const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(WARN_MULTIPLE_TAGS)
    if (data !== null) {
      return of(data === "true")
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const loadWarnMultipleTags = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      ofType(Actions.loadWarnMultipleTagsFromStorage),
      mergeMap(_ => load().pipe(
        map(Slice.setWarnMultipleTags),
        catchError(_ => of(Actions.loadWarnMultipleTagsFromStorageFailed())),
      )),
    )

export default loadWarnMultipleTags(load)

